module.exports = __webpack_public_path__ + "static/media/bars.8157e65d.svg";